// Benefits Widgets - All benefit-related widgets

import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// ============ STANDARD BENEFITS ============
export const BenefitsWidget = ({ formData, setFormData }) => {
  const toggleBenefit = (field) => {
    const currentValue = formData[field] || 0;
    setFormData({ ...formData, [field]: currentValue > 0 ? 0 : (field === 'meal_allowance_daily' ? 10.49 : 50) });
  };

  return (
    <div className="p-2 h-full">
      <div className="text-xs sm:text-sm font-semibold text-brand-600 uppercase mb-2 truncate" title="Benefícios Flexíveis">Benefícios</div>
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <input type="checkbox" checked={(formData.meal_allowance_daily || 0) > 0} onChange={() => toggleBenefit('meal_allowance_daily')} className="w-4 h-4 rounded border-slate-300 text-pink-600 focus:ring-pink-500" />
          <span className="text-xs sm:text-sm text-slate-700 flex-1 truncate" title="Refeição (€/dia)">Refeição</span>
          <Input type="number" value={formData.meal_allowance_daily || ""} onChange={(e) => setFormData({ ...formData, meal_allowance_daily: parseFloat(e.target.value) || 0 })} className="h-7 w-16 sm:w-20 text-xs sm:text-sm text-right text-slate-800" placeholder="€/dia" disabled={(formData.meal_allowance_daily || 0) === 0} />
          <Select value={(formData.meal_allowance_months || 11).toString()} onValueChange={(v) => setFormData({ ...formData, meal_allowance_months: parseInt(v) })} disabled={(formData.meal_allowance_daily || 0) === 0}>
            <SelectTrigger className="h-7 w-16 text-xs text-slate-800 min-w-0"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="11">11m</SelectItem><SelectItem value="12">12m</SelectItem></SelectContent>
          </Select>
        </div>
        <div className="flex items-center gap-2">
          <input type="checkbox" checked={(formData.health_insurance_cost || 0) > 0} onChange={() => { const v = formData.health_insurance_cost || 0; setFormData({ ...formData, health_insurance_cost: v > 0 ? 0 : 55, include_health_insurance: v <= 0 }); }} className="w-4 h-4 rounded border-slate-300 text-pink-600 focus:ring-pink-500" />
          <span className="text-xs sm:text-sm text-slate-700 flex-1 truncate" title="Seguro Saúde (€/mês)">Saúde</span>
          <Input type="number" value={formData.health_insurance_cost || ""} onChange={(e) => { const v = parseFloat(e.target.value) || 0; setFormData({ ...formData, health_insurance_cost: v, include_health_insurance: v > 0 }); }} className="h-7 w-16 sm:w-20 text-xs sm:text-sm text-right text-slate-800" placeholder="€/mês" disabled={(formData.health_insurance_cost || 0) === 0} />
        </div>
        <div className="flex items-center gap-2">
          <input type="checkbox" checked={(formData.ticket_infancia || 0) > 0} onChange={() => { const v = formData.ticket_infancia || 0; setFormData({ ...formData, ticket_infancia: v > 0 ? 0 : 100 }); }} className="w-4 h-4 rounded border-slate-300 text-pink-600 focus:ring-pink-500" />
          <span className="text-xs sm:text-sm text-slate-700 truncate" title="Ticket Infância">T. Infância</span>
          <Input type="number" value={formData.ticket_infancia || ""} onChange={(e) => setFormData({ ...formData, ticket_infancia: parseFloat(e.target.value) || 0 })} className="h-7 w-20 text-xs sm:text-sm text-right text-slate-800" placeholder="€" disabled={(formData.ticket_infancia || 0) === 0} />
          <Select value={(formData.ticket_infancia_months || 12).toString()} onValueChange={(v) => setFormData({ ...formData, ticket_infancia_months: parseInt(v) })} disabled={(formData.ticket_infancia || 0) === 0}>
            <SelectTrigger className="h-7 w-16 text-xs text-slate-800 min-w-0"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="10">10m</SelectItem><SelectItem value="11">11m</SelectItem><SelectItem value="12">12m</SelectItem></SelectContent>
          </Select>
        </div>
        <div className="flex items-center gap-2">
          <input type="checkbox" checked={(formData.insurance_capitalization || 0) > 0} onChange={() => { const v = formData.insurance_capitalization || 0; setFormData({ ...formData, insurance_capitalization: v > 0 ? 0 : 100 }); }} className="w-4 h-4 rounded border-slate-300 text-pink-600 focus:ring-pink-500" />
          <span className="text-xs sm:text-sm text-slate-700 truncate" title="Real Vida (PPR/Capitalização)">Real Vida</span>
          <Input type="number" value={formData.insurance_capitalization || ""} onChange={(e) => setFormData({ ...formData, insurance_capitalization: parseFloat(e.target.value) || 0 })} className="h-7 w-20 text-xs sm:text-sm text-right text-slate-800" placeholder="€" disabled={(formData.insurance_capitalization || 0) === 0} />
          <Select value={(formData.insurance_capitalization_months || 12).toString()} onValueChange={(v) => setFormData({ ...formData, insurance_capitalization_months: parseInt(v) })} disabled={(formData.insurance_capitalization || 0) === 0}>
            <SelectTrigger className="h-7 w-16 text-xs text-slate-800 min-w-0"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="10">10m</SelectItem><SelectItem value="11">11m</SelectItem><SelectItem value="12">12m</SelectItem></SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};

// ============ EMPTY BENEFITS (Recibos/B2B) ============
export const EmptyBenefitsWidget = ({ regime, formData, setFormData }) => (
  <div className="p-2 h-full">
    <div className="text-xs sm:text-sm font-semibold text-brand-600 uppercase mb-2">Benefícios</div>
    <div className="text-[10px] text-slate-400 mb-2">
      {regime === "green_receipts" ? "Recibos Verdes" : "B2B"}
    </div>

    {/* Comparticipação no Seguro de Saúde — B2B/Recibos: valor acrescido à proposta */}
    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        checked={(formData?.health_insurance_cost || 0) > 0}
        onChange={() => {
          const v = formData?.health_insurance_cost || 0;
          setFormData && setFormData({
            ...formData,
            health_insurance_cost: v > 0 ? 0 : 55,
            include_health_insurance: v <= 0,
          });
        }}
        className="w-4 h-4 rounded border-slate-300 text-pink-600 focus:ring-pink-500 flex-shrink-0"
        data-testid="freelancer-health-checkbox"
      />
      <span className="text-xs text-slate-700 flex-1 truncate" title="Comparticipação no Seguro de Saúde — valor mensal acrescido à proposta">Compart. Saúde</span>
      <Input
        type="number"
        value={formData?.health_insurance_cost || ""}
        onChange={(e) => {
          const v = parseFloat(e.target.value) || 0;
          setFormData && setFormData({ ...formData, health_insurance_cost: v, include_health_insurance: v > 0 });
        }}
        className="h-7 w-20 text-xs text-right text-slate-800"
        placeholder="€/mês"
        disabled={(formData?.health_insurance_cost || 0) === 0}
        data-testid="freelancer-health-value"
      />
    </div>
  </div>
);

// ============ EMPTY CUSTOM BENEFITS ============
export const EmptyCustomBenefitsWidget = () => (
  <div className="p-2 h-full flex flex-col items-center justify-center">
    <div className="text-xs sm:text-sm font-semibold text-slate-400 uppercase mb-2">Benefícios Custom</div>
    <div className="text-xs text-muted-foreground text-center">N/A</div>
  </div>
);

// ============ PERM BENEFITS ============
export const EmptyPermBenefitsWidget = ({ label = "Benefícios", formData, setFormData }) => {
  const toggleBenefit = (field, defaultValue) => {
    const currentValue = formData?.[field] || 0;
    setFormData && setFormData({ ...formData, [field]: currentValue > 0 ? 0 : defaultValue });
  };

  return (
    <div className="p-2 h-full">
      <div className="text-xs sm:text-sm font-semibold text-brand-600 uppercase mb-2">{label}</div>
      <p className="text-xs text-muted-foreground mb-2">Benefícios incluídos no cálculo da Fee</p>
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <input type="checkbox" checked={(formData?.perm_meal_allowance || 0) > 0} onChange={() => toggleBenefit('perm_meal_allowance', 10.46)} className="w-4 h-4 rounded border-slate-300 text-pink-600 focus:ring-pink-500" />
          <span className="text-xs text-slate-700 flex-1">Refeição</span>
          <Input type="number" step="0.01" value={formData?.perm_meal_allowance || ""} onChange={(e) => setFormData && setFormData({ ...formData, perm_meal_allowance: parseFloat(e.target.value) || 0 })} className="h-7 w-16 text-xs text-right text-slate-800" placeholder="€/dia" disabled={(formData?.perm_meal_allowance || 0) === 0} title="Valor por dia útil" />
          <Input type="number" min="1" max="31" value={formData?.perm_meal_days || 22} onChange={(e) => setFormData && setFormData({ ...formData, perm_meal_days: parseInt(e.target.value) || 22 })} className="h-7 w-12 text-xs text-right text-slate-800" placeholder="22" disabled={(formData?.perm_meal_allowance || 0) === 0} title="Dias úteis por mês" />
          <Select value={(formData?.perm_meal_months || 11).toString()} onValueChange={(v) => setFormData && setFormData({ ...formData, perm_meal_months: parseInt(v) })} disabled={(formData?.perm_meal_allowance || 0) === 0}>
            <SelectTrigger className="h-7 w-14 text-xs text-slate-800 min-w-0"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="11">11m</SelectItem><SelectItem value="12">12m</SelectItem></SelectContent>
          </Select>
        </div>
        <div className="flex items-center gap-2">
          <input type="checkbox" checked={(formData?.perm_health_insurance || 0) > 0} onChange={() => toggleBenefit('perm_health_insurance', 50)} className="w-4 h-4 rounded border-slate-300 text-pink-600 focus:ring-pink-500" />
          <span className="text-xs text-slate-700 flex-1">Saúde</span>
          <Input type="number" value={formData?.perm_health_insurance || ""} onChange={(e) => setFormData && setFormData({ ...formData, perm_health_insurance: parseFloat(e.target.value) || 0 })} className="h-7 w-20 text-xs text-right text-slate-800" placeholder="€/mês" disabled={(formData?.perm_health_insurance || 0) === 0} />
          <Select value={(formData?.perm_health_months || 12).toString()} onValueChange={(v) => setFormData && setFormData({ ...formData, perm_health_months: parseInt(v) })} disabled={(formData?.perm_health_insurance || 0) === 0}>
            <SelectTrigger className="h-7 w-16 text-xs text-slate-800 min-w-0"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="10">10m</SelectItem><SelectItem value="11">11m</SelectItem><SelectItem value="12">12m</SelectItem></SelectContent>
          </Select>
        </div>
        <div className="flex items-center gap-2">
          <input type="checkbox" checked={(formData?.perm_ppr || 0) > 0} onChange={() => toggleBenefit('perm_ppr', 100)} className="w-4 h-4 rounded border-slate-300 text-pink-600 focus:ring-pink-500" />
          <span className="text-xs text-slate-700 flex-1">Prémio</span>
          <Input type="number" value={formData?.perm_ppr || ""} onChange={(e) => setFormData && setFormData({ ...formData, perm_ppr: parseFloat(e.target.value) || 0 })} className="h-7 w-20 text-xs text-right text-slate-800" placeholder="€/mês" disabled={(formData?.perm_ppr || 0) === 0} />
          <Select value={(formData?.perm_ppr_months || 12).toString()} onValueChange={(v) => setFormData && setFormData({ ...formData, perm_ppr_months: parseInt(v) })} disabled={(formData?.perm_ppr || 0) === 0}>
            <SelectTrigger className="h-7 w-16 text-xs text-slate-800 min-w-0"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="10">10m</SelectItem><SelectItem value="11">11m</SelectItem><SelectItem value="12">12m</SelectItem></SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};

// ============ EMPTY EQUIPMENT (Perm mode) ============
export const EmptyEquipmentWidget = () => (
  <div className="p-2 h-full flex flex-col items-center justify-center">
    <div className="text-xs sm:text-sm font-semibold text-slate-400 uppercase mb-2">Equipamento</div>
    <div className="text-xs text-muted-foreground text-center">
      Modo Perm<br />
      <span className="text-slate-400">não aplicável</span>
    </div>
  </div>
);

// ============ CUSTOM BENEFITS ============
export const CustomBenefitsWidget = ({ customBenefits, formData, setFormData }) => {
  const selectedBenefits = formData.selected_benefits || [];
  
  const toggleBenefit = (benefitId) => {
    const newSelected = selectedBenefits.includes(benefitId)
      ? selectedBenefits.filter(id => id !== benefitId)
      : [...selectedBenefits, benefitId];
    setFormData({ ...formData, selected_benefits: newSelected });
  };
  
  const applicableBenefits = customBenefits?.filter(b => {
    const appliesTo = b.applies_to || [];
    // Perm é um business_type, não regime_type — verifica primeiro
    if (formData.business_type === "perm") return appliesTo.includes("perm");
    if (formData.regime_type === "contract") return appliesTo.includes("contract");
    if (formData.regime_type === "green_receipts") return appliesTo.includes("green_receipts");
    if (formData.regime_type === "b2b") return appliesTo.includes("b2b");
    return false;
  }) || [];

  if (applicableBenefits.length === 0) {
    return (
      <div className="p-2 h-full flex flex-col items-center justify-center">
        <div className="text-xs sm:text-sm font-semibold text-slate-400 uppercase mb-2">Benefícios Custom</div>
        <div className="text-xs text-muted-foreground text-center">Sem benefícios customizados</div>
      </div>
    );
  }

  return (
    <div className="p-2 h-full">
      <div className="text-xs sm:text-sm font-semibold text-brand-600 uppercase mb-2">Benefícios Custom</div>
      <div className="space-y-1">
        {applicableBenefits.map(benefit => (
          <div key={benefit.id} className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={selectedBenefits.includes(benefit.id)}
              onChange={() => toggleBenefit(benefit.id)}
              className="w-4 h-4 rounded border-slate-300 text-purple-600 focus:ring-purple-500"
            />
            <span className="text-xs text-slate-700 flex-1 truncate" title={benefit.name}>{benefit.name}</span>
            <span className="text-xs text-slate-500 font-mono">{new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(benefit.value)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

// ============ COMBINED BENEFITS (Unified) ============
export const CombinedBenefitsWidget = ({ formData, setFormData, customBenefits, benefitSettings }) => {
  const defaultHealthCost = benefitSettings?.health_insurance_cost ?? 55;
  const defaultDependentCost = benefitSettings?.health_insurance_dependent_cost ?? 25;
  const defaultMealCard = benefitSettings?.meal_card_limit ?? 10.49;

  // Get health insurance cost for an age, using configured tiers from /admin/benefits
  const getHealthCostForAge = (age) => {
    if (age == null || age === "" || isNaN(age) || age < 0) return null;
    const a = parseInt(age);
    if (a < 25) return parseFloat(benefitSettings?.health_age_below_25 ?? benefitSettings?.health_age_25_35 ?? 44);
    if (a <= 35) return parseFloat(benefitSettings?.health_age_25_35 ?? 44);
    if (a <= 50) return parseFloat(benefitSettings?.health_age_36_50 ?? 55);
    if (a <= 64) return parseFloat(benefitSettings?.health_age_51_64 ?? 92);
    return parseFloat(benefitSettings?.health_age_above_64 ?? benefitSettings?.health_age_51_64 ?? 92);
  };

  const toggleBenefit = (field, defaultValue) => {
    const includeField = `include_${field}`;
    const isActive = !!formData[includeField];
    const updates = {
      ...formData,
      [includeField]: !isActive,
      [field]: !isActive ? defaultValue : 0,
    };
    if (field === 'health_insurance_cost') {
      updates.include_health_insurance = !isActive;
      if (isActive) {
        updates.health_insurance_dependents = 0;
        updates.include_health_dependents = false;
      }
    }
    setFormData(updates);
  };

  // Helper: um benefício "está activo" se o utilizador ligou o checkbox.
  // Não depende do valor ser >0 — assim o checkbox mantém-se marcado mesmo
  // que o utilizador esvazie o campo do valor.
  const isBenefitOn = (field) => {
    const includeField = `include_${field}`;
    // Retro-compatibilidade: se include flag ainda não existe, cai no valor > 0.
    if (formData[includeField] !== undefined) return !!formData[includeField];
    return (formData[field] || 0) > 0;
  };
  
  const selectedBenefits = formData.selected_benefits || [];
  const customBenefitsMonths = formData.custom_benefits_months || {};
  const customBenefitsValues = formData.custom_benefits_values || {};
  
  const toggleCustomBenefit = (benefitId) => {
    const newSelected = selectedBenefits.includes(benefitId)
      ? selectedBenefits.filter(id => id !== benefitId)
      : [...selectedBenefits, benefitId];
    setFormData({ ...formData, selected_benefits: newSelected });
  };
  
  const updateCustomBenefitMonths = (benefitId, months) => {
    setFormData({ 
      ...formData, 
      custom_benefits_months: { ...customBenefitsMonths, [benefitId]: months }
    });
  };

  const updateCustomBenefitValue = (benefitId, value) => {
    setFormData({
      ...formData,
      custom_benefits_values: { ...customBenefitsValues, [benefitId]: value },
    });
  };
  
  const applicableBenefits = customBenefits?.filter(b => {
    const appliesTo = b.applies_to || [];
    if (formData.business_type === "perm") return appliesTo.includes("perm");
    if (formData.regime_type === "contract") return appliesTo.includes("contract");
    return false;
  }) || [];

  return (
    <div className="p-2 h-full overflow-y-auto">
      <div className="text-xs sm:text-sm font-semibold text-brand-600 uppercase mb-2">Benefícios</div>
      <div className="space-y-2">
        {/* Refeição */}
        <div className="flex items-center gap-2">
          <input type="checkbox" checked={isBenefitOn('meal_allowance_daily')} onChange={() => toggleBenefit('meal_allowance_daily', defaultMealCard)} className="w-4 h-4 rounded border-slate-300 text-pink-600 focus:ring-pink-500 flex-shrink-0" data-testid="benefit-meal-checkbox" />
          <span className="text-xs text-slate-700 w-16 flex-shrink-0">Refeição</span>
          <Input type="number" value={formData.meal_allowance_daily || ""} onChange={(e) => setFormData({ ...formData, meal_allowance_daily: parseFloat(e.target.value) || 0 })} className="h-7 w-24 text-xs text-right text-slate-800" placeholder="€/dia" disabled={!isBenefitOn('meal_allowance_daily')} data-testid="benefit-meal-value" />
          <span className="text-[10px] text-slate-400 flex-shrink-0">€/dia</span>
          <Select value={(formData.meal_allowance_months || 11).toString()} onValueChange={(v) => setFormData({ ...formData, meal_allowance_months: parseInt(v) })} disabled={!isBenefitOn('meal_allowance_daily')}>
            <SelectTrigger className="h-7 w-16 text-xs flex-shrink-0" data-testid="benefit-meal-months"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="11">11m</SelectItem><SelectItem value="12">12m</SelectItem></SelectContent>
          </Select>
        </div>
        
        {/* Saúde — escalão automático por idade (Bug 3: campo "valor" oculto, mostra só idade) */}
        <div className="flex items-center gap-2">
          <input type="checkbox" checked={(formData.health_insurance_cost || 0) > 0 || formData.consultant_age != null} onChange={() => {
            const active = (formData.health_insurance_cost || 0) > 0 || formData.consultant_age != null;
            setFormData({
              ...formData,
              health_insurance_cost: active ? 0 : defaultHealthCost,
              include_health_insurance: !active,
              consultant_age: active ? null : (formData.consultant_age ?? null),
            });
          }} className="w-4 h-4 rounded border-slate-300 text-pink-600 focus:ring-pink-500 flex-shrink-0" data-testid="benefit-health-checkbox" />
          <span className="text-xs text-slate-700 w-16 flex-shrink-0">Saúde</span>
          <Input type="number" min="0" value={formData.consultant_age ?? ""} onChange={(e) => {
            const v = e.target.value === "" ? null : parseInt(e.target.value);
            const tierCost = getHealthCostForAge(v);
            setFormData({
              ...formData,
              consultant_age: v,
              include_health_insurance: true,
              // Auto-fill: when a valid age is set, the configured tier value is applied
              health_insurance_cost: tierCost != null ? tierCost : (formData.health_insurance_cost || 0),
            });
          }} className="h-7 w-20 text-xs text-right text-slate-800" placeholder="Idade" data-testid="benefit-health-age" />
          <span className="text-[10px] text-slate-400 flex-shrink-0">anos</span>
        </div>

        {/* Agregado familiar — sub-linhas por pessoa com idade */}
        {((formData.health_insurance_cost || 0) > 0 || formData.consultant_age != null) && (
          <div className="pl-6 space-y-1 bg-pink-50/30 rounded py-1" data-testid="health-dependents-block">
            <div className="flex items-center gap-2">
              <span className="text-xs text-slate-700 w-16 flex-shrink-0">Agregado</span>
              <Button type="button" size="sm" variant="outline" className="h-6 px-2 text-xs" onClick={() => {
                const ages = Array.isArray(formData.dependents_ages) ? [...formData.dependents_ages] : [];
                ages.push(null);
                setFormData({ ...formData, dependents_ages: ages, health_insurance_dependents: ages.length });
              }} data-testid="add-dependent-btn">+ Pessoa</Button>
              <span className="text-[10px] text-slate-500">
                {(formData.dependents_ages?.length || 0)} pessoa(s)
              </span>
            </div>
            {(formData.dependents_ages || []).map((age, idx) => {
              const depTierCost = getHealthCostForAge(age);
              const depCustomCosts = formData.dependents_costs || [];
              const depCost = depCustomCosts[idx] != null && depCustomCosts[idx] !== "" ? depCustomCosts[idx] : (depTierCost != null ? depTierCost : "");
              return (
              <div key={idx} className="flex items-center gap-2 pl-6" data-testid={`dependent-row-${idx}`}>
                <span className="text-[10px] text-slate-500 w-10 flex-shrink-0">#{idx + 1}</span>
                <Input type="number" min="0" value={age == null || age === 0 ? "" : age} onChange={(e) => {
                  const newAges = [...(formData.dependents_ages || [])];
                  newAges[idx] = e.target.value === "" ? null : parseInt(e.target.value);
                  setFormData({ ...formData, dependents_ages: newAges });
                }} className="h-6 w-16 text-xs text-right text-slate-800" placeholder="Idade" data-testid={`dependent-age-${idx}`} />
                <span className="text-[10px] text-slate-400">anos</span>
                <Button type="button" size="sm" variant="ghost" className="h-6 px-2 text-xs text-red-500 ml-auto" onClick={() => {
                  const newAges = (formData.dependents_ages || []).filter((_, i) => i !== idx);
                  const newCosts = (formData.dependents_costs || []).filter((_, i) => i !== idx);
                  setFormData({ ...formData, dependents_ages: newAges, dependents_costs: newCosts, health_insurance_dependents: newAges.length });
                }} data-testid={`remove-dependent-${idx}`}>✕</Button>
              </div>
              );
            })}
          </div>
        )}
        
        {/* Ticket Infância */}
        <div className="flex items-center gap-2">
          <input type="checkbox" checked={isBenefitOn('ticket_infancia')} onChange={() => toggleBenefit('ticket_infancia', 100)} className="w-4 h-4 rounded border-slate-300 text-pink-600 focus:ring-pink-500 flex-shrink-0" data-testid="benefit-infancia-checkbox" />
          <span className="text-xs text-slate-700 w-16 flex-shrink-0">T.Infância</span>
          <Input type="number" value={formData.ticket_infancia || ""} onChange={(e) => setFormData({ ...formData, ticket_infancia: parseFloat(e.target.value) || 0 })} className="h-7 w-24 text-xs text-right text-slate-800" placeholder="€/mês" disabled={!isBenefitOn('ticket_infancia')} data-testid="benefit-infancia-value" />
          <Select value={(formData.ticket_infancia_months || 12).toString()} onValueChange={(v) => setFormData({ ...formData, ticket_infancia_months: parseInt(v) })} disabled={!isBenefitOn('ticket_infancia')}>
            <SelectTrigger className="h-7 w-16 text-xs flex-shrink-0"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="10">10m</SelectItem><SelectItem value="11">11m</SelectItem><SelectItem value="12">12m</SelectItem></SelectContent>
          </Select>
        </div>
        
        {/* Real Vida (antigo PPR) */}
        <div className="flex items-center gap-2">
          <input type="checkbox" checked={isBenefitOn('insurance_capitalization')} onChange={() => toggleBenefit('insurance_capitalization', 100)} className="w-4 h-4 rounded border-slate-300 text-pink-600 focus:ring-pink-500 flex-shrink-0" data-testid="benefit-ppr-checkbox" />
          <span className="text-xs text-slate-700 w-16 flex-shrink-0" title="Real Vida (PPR/Capitalização)">Real Vida</span>
          <Input type="number" value={formData.insurance_capitalization || ""} onChange={(e) => setFormData({ ...formData, insurance_capitalization: parseFloat(e.target.value) || 0 })} className="h-7 w-24 text-xs text-right text-slate-800" placeholder="€/mês" disabled={!isBenefitOn('insurance_capitalization')} data-testid="benefit-ppr-value" />
          <Select value={(formData.insurance_capitalization_months || 12).toString()} onValueChange={(v) => setFormData({ ...formData, insurance_capitalization_months: parseInt(v) })} disabled={!isBenefitOn('insurance_capitalization')}>
            <SelectTrigger className="h-7 w-16 text-xs flex-shrink-0"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="10">10m</SelectItem><SelectItem value="11">11m</SelectItem><SelectItem value="12">12m</SelectItem></SelectContent>
          </Select>
        </div>
        
        {/* Custom Benefits */}
        {applicableBenefits.map(benefit => {
          const currentValue = customBenefitsValues[benefit.id] !== undefined
            ? customBenefitsValues[benefit.id]
            : benefit.value;
          return (
            <div key={benefit.id} className="flex items-center gap-2">
              <input type="checkbox" checked={selectedBenefits.includes(benefit.id)} onChange={() => toggleCustomBenefit(benefit.id)} className="w-4 h-4 rounded border-slate-300 text-purple-600 focus:ring-purple-500 flex-shrink-0" data-testid={`benefit-custom-${benefit.id}-checkbox`} />
              <span className="text-xs text-slate-700 w-16 flex-shrink-0 truncate" title={benefit.name}>{benefit.name}</span>
              <Input
                type="number"
                value={currentValue ?? ""}
                onChange={(e) => updateCustomBenefitValue(benefit.id, e.target.value === "" ? null : parseFloat(e.target.value))}
                className="h-7 w-24 text-xs text-right text-slate-800"
                placeholder={benefit.value?.toString() || "€"}
                disabled={!selectedBenefits.includes(benefit.id)}
                data-testid={`benefit-custom-${benefit.id}-value`}
              />
              <Select value={(customBenefitsMonths[benefit.id] || benefit.payment_months || 12).toString()} onValueChange={(v) => updateCustomBenefitMonths(benefit.id, parseInt(v))} disabled={!selectedBenefits.includes(benefit.id)}>
                <SelectTrigger className="h-7 w-16 text-xs flex-shrink-0"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="10">10m</SelectItem><SelectItem value="11">11m</SelectItem><SelectItem value="12">12m</SelectItem></SelectContent>
              </Select>
            </div>
          );
        })}

        {/* Ajuda de Custo KM */}
        <div className="pt-2 mt-1 border-t border-slate-200">

        {/* Internacional Benefits */}
        {formData.placement_type === "international" && (
          <div className="mb-3 space-y-2 p-2 bg-blue-50 rounded-lg border border-blue-200">
            <div className="text-[10px] font-semibold text-blue-700 uppercase">Custos Internacionais (1x, diluídos)</div>
            {[
              { key: "intl_travel", label: "Viagem", monthsKey: "intl_travel_months" },
              { key: "intl_lawyers", label: "Advogados", monthsKey: "intl_lawyers_months" },
              { key: "intl_visa", label: "Visto", monthsKey: "intl_visa_months" },
              { key: "intl_family_reunification", label: "Reag. Fam.", monthsKey: "intl_family_reunification_months" },
            ].map(({ key, label, monthsKey }) => {
              const defaultVal = benefitSettings?.[key] ?? 500;
              const defaultMonths = benefitSettings?.[monthsKey] ?? 11;
              return (
                <div key={key} className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={(formData[key] || 0) > 0}
                    onChange={() => setFormData({
                      ...formData,
                      [key]: formData[key] > 0 ? 0 : defaultVal,
                      [monthsKey]: formData[monthsKey] || defaultMonths,
                    })}
                    className="w-4 h-4 rounded border-blue-300 text-blue-600 focus:ring-blue-500 flex-shrink-0"
                    data-testid={`benefit-${key}-checkbox`}
                  />
                  <span className="text-xs text-slate-700 w-16 flex-shrink-0 truncate" title={label}>{label}</span>
                  <Input
                    type="number"
                    value={formData[key] || ""}
                    onChange={(e) => setFormData({ ...formData, [key]: parseFloat(e.target.value) || 0 })}
                    className="h-7 w-24 text-xs text-right text-slate-800"
                    placeholder="€ total"
                    disabled={(formData[key] || 0) === 0}
                  />
                  <Select value={(formData[monthsKey] || defaultMonths).toString()} onValueChange={(v) => setFormData({ ...formData, [monthsKey]: parseInt(v) })} disabled={(formData[key] || 0) === 0}>
                    <SelectTrigger className="h-7 w-16 text-xs flex-shrink-0"><SelectValue /></SelectTrigger>
                    <SelectContent><SelectItem value="11">11m</SelectItem><SelectItem value="12">12m</SelectItem></SelectContent>
                  </Select>
                </div>
              );
            })}
          </div>
        )}

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={isBenefitOn('km_allowance')}
              onChange={(e) => {
                if (!e.target.checked) {
                  setFormData({ ...formData, include_km_allowance: false, km_allowance: 0, ajuda_custo_km_count: 0 });
                } else {
                  if (formData.ajuda_custo_type === "km") {
                    setFormData({ ...formData, include_km_allowance: true, ajuda_custo_km_count: 500, km_allowance: Math.round(0.36 * 500 * 100) / 100 });
                  } else {
                    setFormData({ ...formData, include_km_allowance: true, km_allowance: 150 });
                  }
                }
              }}
              className="w-4 h-4 rounded border-slate-300 text-amber-600 focus:ring-amber-500 flex-shrink-0"
              data-testid="benefit-km-checkbox"
            />
            <span className="text-xs text-slate-700 w-16 flex-shrink-0">Deslocação</span>
            <Select 
              value={formData.ajuda_custo_type || "fixed"} 
              onValueChange={(v) => {
                if (v === "km") {
                  const price = formData.ajuda_custo_km_price || 0.36;
                  const count = formData.ajuda_custo_km_count || 500;
                  setFormData({ ...formData, ajuda_custo_type: v, km_allowance: Math.round(price * count * 100) / 100 });
                } else {
                  setFormData({ ...formData, ajuda_custo_type: v });
                }
              }}
            >
              <SelectTrigger className="h-7 w-16 text-xs flex-shrink-0"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="fixed">Fixo</SelectItem>
                <SelectItem value="km">KM</SelectItem>
              </SelectContent>
            </Select>
            {(formData.ajuda_custo_type || "fixed") === "fixed" ? (
              <Input 
                type="number" 
                value={formData.km_allowance || ""} 
                onChange={(e) => setFormData({ ...formData, km_allowance: parseFloat(e.target.value) || 0 })} 
                className="h-7 w-24 text-xs text-right text-slate-800" 
                placeholder="€/mês"
                data-testid="benefit-km-value"
              />
            ) : (
              <div className="flex items-center gap-1">
                <Input 
                  type="number" 
                  value={formData.ajuda_custo_km_price || ""} 
                  onChange={(e) => {
                    const price = parseFloat(e.target.value) || 0;
                    const count = formData.ajuda_custo_km_count || 0;
                    setFormData({ ...formData, ajuda_custo_km_price: price, km_allowance: Math.round(price * count * 100) / 100 });
                  }} 
                  className="h-7 w-14 text-xs text-right text-slate-800" 
                  placeholder="€/km"
                  step="0.01"
                  data-testid="benefit-km-price"
                />
                <span className="text-[10px] text-slate-400">x</span>
                <Input 
                  type="number" 
                  value={formData.ajuda_custo_km_count || ""} 
                  onChange={(e) => {
                    const count = parseFloat(e.target.value) || 0;
                    const price = formData.ajuda_custo_km_price || 0.36;
                    setFormData({ ...formData, ajuda_custo_km_count: count, km_allowance: Math.round(price * count * 100) / 100 });
                  }} 
                  className="h-7 w-16 text-xs text-right text-slate-800" 
                  placeholder="km"
                  data-testid="benefit-km-count"
                />
              </div>
            )}
            <Select value={(formData.km_allowance_months || 11).toString()} onValueChange={(v) => setFormData({ ...formData, km_allowance_months: parseInt(v) })}>
              <SelectTrigger className="h-7 w-16 text-xs flex-shrink-0"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="10">10m</SelectItem><SelectItem value="11">11m</SelectItem><SelectItem value="12">12m</SelectItem></SelectContent>
            </Select>
          </div>
          {(formData.ajuda_custo_type === "km" && formData.km_allowance > 0) && (
            <div className="text-[10px] text-amber-600 mt-1 ml-6">
              = {new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(formData.km_allowance)}/mês
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
